
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import Chat from "@/components/Chat";
import { useAssistantData } from "@/hooks/useAssistantData";

const Index = () => {
  // Use "midnight-hotel" as the default slug (known to exist in the database)
  const { assistantData, isLoading } = useAssistantData("midnight-hotel");
  
  useEffect(() => {
    if (!isLoading && assistantData?.assistant_data?.hotel_details?.name) {
      document.title = `alfie — ${assistantData.assistant_data.hotel_details.name}`;
    } else {
      document.title = "alfie | Your 24/7 Concierge";
    }
  }, [assistantData, isLoading]);
  
  return (
    <>
      <Helmet>
        <title>
          {assistantData?.assistant_data?.hotel_details?.name 
            ? `alfie — ${assistantData.assistant_data.hotel_details.name}`
            : "alfie | Your 24/7 Concierge"}
        </title>
        <meta 
          name="description" 
          content={`Your 24/7 Concierge ${assistantData?.assistant_data?.hotel_details?.name ? `at ${assistantData.assistant_data.hotel_details.name}` : ''}`} 
        />
      </Helmet>
      
      <Chat urlSlug="midnight-hotel" />
    </>
  );
};

export default Index;
